import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../../../assets/stylesheets/Footer.scss'
import { NavLink, useParams } from "react-router-dom";
import configs from "../../../../config/config";
import Notification from '../../../Units/Notification';
import { useSelector } from "react-redux";
import { getCountOfUnreadMessages, getCurrentClubPendingMembers } from "../../../../store/selectors";

const items = configs.clubMenuItems;

const Footer = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const countOfUnreadMessages = useSelector(getCountOfUnreadMessages);
    const pendingmembers = useSelector(getCurrentClubPendingMembers);

    return (
        <nav className={`footer`}>
            {
                items.map(item => (
                    <NavLink
                        key={item}
                        activeClassName="active"
                        to={`/club/${id}/${item}`}
                        className={`footerItem clubFooter ${item}`}
                    >
                        <div className={`footerContent`}>
                            <p className={`icon ${item}`}></p>
                            <span>{t(`footer.items.${item}`)}</span>
                        </div>
                        {/* { item === 'messages' && <Notification count={countOfUnreadMessages} /> } */}
                        { item === 'members' && <Notification count={pendingmembers.length} /> }
                    </NavLink>
                ))
            }
        </nav>
    )
};
export default Footer;
